export function createCookie(cookieName: string, cookieValue: string, expireDate?: Date): void {
  let date;
  if (expireDate) {
    date = expireDate;
  } else {
    date = new Date();
    date.setFullYear(date.getFullYear() + 1);
  }

  document.cookie = `${cookieName}=${cookieValue};expires=${date.toString()};path=/`;
}
